import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { applyTheme } from '@/services/whitelabel';
import { useFeaturesStore } from '@/stores/features';
import { installGlobalErrorHandlers } from '@/services/observability/clientErrors';
import { initErrorMonitoring } from '@/services/observability/sentry';
import { installChatwootWidget } from '@/services/support/chatwoot';
import '@/styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('root element missing');

const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  navigator.serviceWorker.register('/sw.js').catch(() => {});
};

const boot = () => {
  initErrorMonitoring();
  installGlobalErrorHandlers();
  applyTheme();
  installChatwootWidget();
  void useFeaturesStore.getState().hydrate();
  registerServiceWorker();
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

boot();
